import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["container", "item", "position"]

  connect() {
    this.sortable = new Sortable(this.hasContainerTarget ? this.containerTarget : this.element, {
      draggable: '[data-sortable-list-target~="item"]',
      handle: '[data-sortable-list-target~="handle"]',
      animation: 150,
      ghostClass: "opacity-50",
      fallbackOnBody: true,
      onEnd: () => this.updatePositions()
    })
  }

  disconnect() {
    this.sortable.destroy()
  }

  updatePositions() {
    this.itemTargets.forEach((item, position) => {
      const field = item.querySelector('[data-sortable-list-target~="position"]')
      if (field) field.value = position
    })
  }
}
